module.exports = __webpack_public_path__ + "img/FR18169.b021b222.png";